import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import iconSearch from '../images/additionalDocument/search-icon.svg'
import iconLink from '../images/additionalDocument/link-icon.svg'

function AdditionalDocumentError(props) {
  const errorCode = props.errorCode

  const [ headerMessage, setHeaderMessage ] = useState('')
  const [ textMessage, setTextMessage ] = useState('')
  const [ showIconLink, setShowIconLink ] = useState(false)
  
  useEffect(() => {
    if(errorCode == "token_expired"){
      setShowIconLink(true)
      setHeaderMessage('ลิงค์นี้ได้หมดอายุแล้ว')
      setTextMessage('หากมีข้อสงสัยหรือต้องการสอบถาม\nเรื่องการเรียกร้องสินไหมกรุณาติดต่อ\nที่หมายเลข 1231 กด 4')
    }else{
      setShowIconLink(false)
      setHeaderMessage('ไม่พบหน้านี้')
      setTextMessage('ขออภัย หน้าที่คุณกำลังมองหาไม่มีอยู่หรือถูกย้ายไปแล้ว\nหากมี ข้อสงสัยหรือต้องการสอบถามเรื่องการเรียกร้อง\nสินไหม กรุณาติดต่อที่หมายเลข 1231 กด 4')
    }
  }, []);
  

  return (
    <div className=' flex-wrap w-full flex h-screen items-center fixed top-0'>
          <div className="flex flex-wrap w-full justify-center p-0  ">

          <div className='md:w-[1092px md:px-20 md:pb-20 md:pt-[40px] ' >

            <div className=" flex flex-wrap w-full px-4 py-6 md:pt-[48px] md:pb-12  md:px-0">
                
                <div className='flex w-full flex-col'>
                  <div className='justify-center mt-[42px]'>
                    <div className='flex w-full justify-center'>
                      <div className='icon-center bg-[#F0F0F0]  w-[48px] h-[48px]'>
                        { showIconLink ? 
                            <img src={iconLink} className=' mx-auto w-[24px] h-[24px]' alt="" />
                            :
                            <img src={iconSearch} className='mx-auto w-[24px] h-[24px]' alt="" />
                        }
                      </div>
                    </div>
                  </div>
                  <span className='w-full mt-[16px] text-center font-thonburi text-[16px] font-semibold leading-6'>{headerMessage}</span>
                </div>

                <div className='flex-wrap w-full text-center'>
                  <span className='font-thonburi whitespace-pre text-[14px] font-normal text-[#666] leading-5'>{textMessage}</span>
                </div>

            </div>

          </div>

          </div>
    </div>
  )
}


export default connect()(AdditionalDocumentError);